export default {
  modal: {
    reviewMethod: {
      title: 'Review Method',
      description: 'Please select the review method, which cannot be modified after submission',
      form: {
        button: {
          confirm: 'Confirm',
          auto: 'Auto Review',
          manual: 'Manual Review',
        },
      },
      message: {
        selectMethod: 'Please select the review method',
      },
    },
    finishSubmit: {
      title: 'Real Name Authentication',
      description: 'Please wait for review',
      button: {
        completed: 'I have completed',
        confirm: 'Go to authentication',
      },
    },
  },
  alert: {
    '0': 'Pending',
    '1': 'Pending Review',
    '9': 'Approved',
    '-1': 'Rejected',
    realNameNotVerified:
      'Please complete the real name authentication first, then you can sign the agreement！',
  },
  form: {
    input: {
      placeholder: 'Please enter',
    },
    country: {},
    number: {
      placeholder: 'Please enter',
    },
    textarea: {
      placeholder: 'Please enter',
    },
    file: {
      placeholder: 'Please upload',
      uploadSelectorText: 'Upload file',
      uploadNoFile: 'No file',
    },
    image: {
      placeholder: 'Please upload',
      uploadSelectorText: 'Upload image',
      uploadNoFile: 'No image',
    },
    date: {
      placeholder: 'Please select date',
      startDate: 'Start Date',
      endDate: 'End Date',
    },
    idcard: {
      longTerm: 'Long-term',
    },
    time: {
      placeholder: 'Please select time',
    },
    rule: {
      required: '{label} is required',
      pattern: 'Please enter a valid {label}',
      uploadError: '{label} failed to upload, please try again',
      uploadInvalid: 'Please successfully upload at least one {label}',
      uploading: '{label} is uploading, please wait',
      minAge: 'Please enter a valid date of birth (age must be greater than or equal to 18)',
      phonesDuplicate: 'The two phone numbers cannot be the same',
      alnumOnly: '{label} can contain only letters and numbers',
    },
    button: {
      submit: 'Submit',
    },
    agreement: {
      signLabel: 'Signature',
      signLabelLoading: 'Loading...',
      required: 'Please confirm that you have read and agreed to',
      eSignConsentStatement:
        'I confirm that I have carefully read all the terms and conditions of the Risk Acknowledgement And Disclosure, and that the information I have provided is true and accurate. I agree to sign this legally binding contract and accept the associated responsibilities. I understand and agree that this electronic signature is equivalent to a handwritten signature.',
    },
  },
}
